import ClassesList from "./components/List"
import ClassesForm from "./components/Form"
import ClassesView from "./components/View"

let module = "classes"

export default [
  { path: "classes", component: ClassesList, meta: { module: module, permissions: ["class-access"] } },
  {
    path: "classes/create",
    component: ClassesForm,
    props: true,
    meta: { module: module, permissions: ["class-create"] }
  },
  {
    path: "classes/edit/:id",
    component: ClassesForm,
    props: true,
    meta: { module: module, permissions: ["class-edit"] }
  },
  {
    path: "classes/view/:id",
    component: ClassesView,
    props: true,
    meta: { module: module, permissions: ["class-access"] }
  }
]
